<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th class="checkbox tableCheckbox">
            <input type="checkbox" id="checkAll" v-model="checkedAll" @change="onCheckedAll($event)">
            <label for="checkAll"><span class="blind">{{locale.all}}</span></label>
          </th>
          <th style="width: 400px;">{{locale.title}}</th>
          <th>{{locale.category}}</th>
          <th>{{locale.state}}</th>
          <th class="center">{{locale.table_createat}}</th>
          <th class="center">{{locale.table_updateat}}</th>
          <th class="center icoCell">{{locale.copy}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!list.length && !(main && main.pageid)" class="noData"><td colspan="7">{{locale.page_list_nodata}}</td></tr>
        <tr v-if="main && main.pageid" class="emphasis">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :value="main.pageid" :id="`check${main.pageid}`" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${main.pageid}`"><span class="blind">check</span></label>
          </td>
          <td>
            <router-link :to="{name: 'pageItem', params: {id: main.pageid}}" class="subject">
              <div class="name">
                <span v-if="main.pageData.thumbnail && main.pageData.thumbnail !== ''" class="thumb"><img :src="main.pageData.thumbnail" :alt="main.pageData.title"></span>
                <span><i>&#10070;</i> {{ main.pageData.title }}</span>
              </div>
              <div class="submitData">
                <div v-if="main.pageData.submit && main.pageData.submit.isSubmit"
                  :class="{invalid: !validateSubmit(main.pageData.submit.submitTo)}"
                  class="submit">
                  <div class="stkr">&#8644;</div>
                  {{getCodeLabel(main.pageData.submit)}}
                </div>
                <div v-if="main.pageData.pIdType"
                  :class="{invalid: !validatePidType(main.pageData.pIdType.id)}"
                  class="pId">{{main.pageData.pIdType.label}}</div>
              </div>
            </router-link>
          </td>
          <td class="ellipsis">
            <div v-for="id in main.pageData.category" :key="id" class="categoryPath">
              <span v-for="(path, index) in categoryPath(id)" :key="index">{{path}}</span>
            </div>
          </td>
          <td :class="{colorGrey: main.pageData.state === '02'}">{{ main.pageData.state === '01' ? locale.state_public : locale.state_private }}</td>
          <td class="center date">{{date(main.createat)}}</td>
          <td class="center date">{{date(main.updateat)}}</td>
          <td class="center">
            <span v-if="pageLimit">-</span>
            <router-link v-else :to="{name: 'pageItem', params: {id: `copy_${main.pageData.id}`, oId: main.pageData.id}}"><img src="~@/assets/img/ico_copy_grey.svg" class="btnIco" alt=""></router-link>
          </td>
        </tr>
        <tr v-for="page in list" :key="page.pageid">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :value="page.pageid" :id="`check${page.pageid}`" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${page.pageid}`"><span class="blind">{{locale.select}}</span></label>
          </td>
          <td>
            <router-link :to="{name: 'pageItem', params: {id: page.pageid}}" class="subject">
              <div class="name">
                <span v-if="page.pageData.thumbnail && page.pageData.thumbnail !== ''" class="thumb"><img :src="page.pageData.thumbnail" :alt="page.pageData.title"></span>
                {{ page.pageData.title }}
              </div>
              <div class="submitData">
                <div v-if="page.pageData.submit && page.pageData.submit.isSubmit"
                  :class="{invalid: !validateSubmit(page.pageData.submit.submitTo)}"
                  class="submit">
                  <div class="stkr">&#8644;</div>
                  {{getCodeLabel(page.pageData.submit)}}
                </div>
                <div v-if="page.pageData.pIdType"
                  :class="{invalid: !validatePidType(page.pageData.pIdType.id)}"
                  class="pId">{{page.pageData.pIdType.label}}</div>
              </div>
            </router-link>
          </td>
          <td class="ellipsis">
            <div v-for="id in page.pageData.category" :key="id" class="categoryPath">
              <span v-for="(path, index) in categoryPath(id)" :key="index">{{path}}</span>
            </div>
          </td>
          <td :class="{colorGrey: page.pageData.state === '02'}">{{ page.pageData.state === '01' ? locale.state_public : locale.state_private }}</td>
          <td class="center date">{{date(page.createat)}}</td>
          <td class="center date">{{date(page.updateat)}}</td>
          <td class="center">
            <span v-if="pageLimit">-</span>
            <router-link v-else :to="{name: 'pageItem', params: {id: `copy_${page.pageData.id}`, oId: page.pageData.id}}"><img src="~@/assets/img/ico_copy_grey.svg" class="btnIco" alt=""></router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DATE from '@/common/date'

export default {
  name: 'PageList',
  props: [
    'locale',
    'pageLimit',
    'init',
    'main',
    'list'
  ],
  computed: {
    ...mapGetters({
      categoryPath: 'category/categoryPath',
      getCheckedCategory: 'category/getChecked',
      getCode: 'admin/codeList',
      getPid: 'admin/pIdType'
    }),
    validateSubmit () {
      return (id) => {
        const codeList = this.getCode.map(x => {
          if (x.id) {
            return x.id
          }
        })
        return codeList.includes(id)
      }
    },
    validatePidType () {
      return (id) => {
        const pIdType = this.getPid.map(x => {
          if (x.id) {
            return x.id
          }
        })
        return pIdType.includes(id)
      }
    },
    test () {
      return this.getPid.map(x => {
        if (x.label) {
          return x.label
        }
      })
    },
    getCodeLabel () {
      return (data) => {
        const id = data.id
        return this.getCode.find(x => x.id === id) ? this.getCode.find(x => x.id === id).label : data.submitLabel
      }
    }
  },
  watch: {
    init (isInit) {
      if (isInit) {
        this.checkedItem = []
      }
    },
    checkedItem (ids) {
      this.$emit('checked', ids)
    }
  },
  created () {
    this.$store.dispatch('admin/getCodes')
    this.$store.dispatch('admin/getPidType')
  },
  data () {
    return {
      checkedItem: [],
      checkedAll: false
    }
  },
  methods: {
    date (date) {
      return DATE.toString(date)
    },
    categoryList (categoryPath) {
      categoryPath.forEach(function (x) {
        x.path.forEach(function (p) {
          return p
        })
      })
    },
    onCheckedAll (e) {
      const checked = e.target.checked
      this.checkedAll = checked
      let allId = []
      if (checked) {
        this.list.forEach(x => {
          allId.push(x.pageid)
        })
        if (typeof (this.main) !== 'undefined') {
          allId.push(this.main.pageid)
        }
      }
      this.checkedItem = allId
    },
    onCheckedItem (e) {
      const checked = e.target.checked
      if (!checked) {
        this.checkedAll = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.categoryPath {
  font-size: 0.9em;
  white-space: nowrap;
  span + span:before {
    content: ">";
    margin: 0 0.5em;
  }
}
.subject .name {
  display: flex;
  align-items: center;
  .thumb {
    position: relative;
    width: 45px;
    height: 45px;
    margin-right: 5px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.submitData {
  display: flex;
  align-items: center;
  margin-top: 3px;
  font-size: 0.85em;
  color: $color-lgrey;
  .pId {
    margin-left: 15px;
    padding: 1px 6px;
    font-size: 10px;
    color: $color-white;
    border-radius: 8px;
    background-color: $color-green;
    &.invalid {
      background-color: $color-red;
    }
  }
}
.subject .submit {
  position: relative;
  vertical-align: middle;
  .stkr {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-top: -8px;
    font-size: 10px;
    text-align: center;
    line-height: 16px;
    color: $color-white;
    border-radius: 100%;
    background-color: $color-green;
  }
  &.invalid {
    text-decoration: line-through;
    .stkr {
      background-color: $color-red;
    }
    .stkr:hover .invalidMessage {
      display: block;
    }
  }
}
</style>
